<div class="page-header">
    <h1 class="page-title">Invoice List</h1>
</div>

<div class="account-field-container">
    <label class="account-info-label">Account #, Name, City</label>
    <div class="account-info">
        205174 - ABC SUPPLY #417 - MALVERN
    </div>
</div>